module.exports = __webpack_public_path__ + "img/setUpCards_4.0c405c6f.jpg";